import { useStyleConfig } from '@tectonic/elemason-components';
import clsx from 'clsx';
import { Button } from '../../../components';
import { useAuthStepper } from './hooks';

import type { FC } from 'react';
import type { AuthStepperWidgetProps } from './AuthStepper.types';

const AuthStepperWidget: FC<AuthStepperWidgetProps> = ({ widget }) => {
  const wData = widget.data!;

  const { config, onClick } = useAuthStepper(widget);
  const containerStyleConfig = useStyleConfig(config?.container ?? {});
  return (
    <div
      style={containerStyleConfig.style}
      className={clsx('flex', containerStyleConfig.className)}
    >
      <Button
        className="grow justify-center"
        onClick={onClick}
        config={config?.button}
        data={wData.cta.button}
      />
    </div>
  );
};

AuthStepperWidget.displayName = 'AuthStepperWidget';

export { AuthStepperWidget };
